export function handleMatchPath({ pattern, pathname }: any): boolean {
  const splitPattern = pattern
    .trim()
    .split("?")
    .filter((token: any) => token !== "");
  const splitPathname = pathname
    .trim()
    .split("?")
    .filter((token: any) => token !== "");
  const match = Boolean(splitPattern[0] === splitPathname[0]);
  return match;
}
